import { render } from "./ShiftTcpaDisclaimerCheckbox.vue?vue&type=template&id=58ce39d7&scoped=true"
import script from "./ShiftTcpaDisclaimerCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./ShiftTcpaDisclaimerCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./ShiftTcpaDisclaimerCheckbox.vue?vue&type=style&index=0&id=58ce39d7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ce39d7"],['__file',"src/Components/Shared/ShiftTcpaDisclaimerCheckbox/ShiftTcpaDisclaimerCheckbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58ce39d7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58ce39d7', __exports__)) {
    api.reload('58ce39d7', __exports__)
  }
  
  module.hot.accept("./ShiftTcpaDisclaimerCheckbox.vue?vue&type=template&id=58ce39d7&scoped=true", () => {
    api.rerender('58ce39d7', render)
  })

}


export default __exports__